import SendPushNotification from '../Notifications/SendPushNotification'
import terminatorErrorMessage from './terminatorErrorMessage'
import TerminatorSetActiveSeason from './TerminatorSetActiveSeason'
import OnlineUsers from '../../components/OnlineUsers'
import { getConfig, saveConfig, getPlayers, getLoginInfo as getTerminatorLoginInfo } from '@severed-links/common.redherrings-reducers/terminatorAdmin'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Row, Col, Button, ButtonGroup, ListGroup, Alert } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import Modal from '@severed-links/common.modal'
import Logins from '../Main/Admin/Logins'
import TerminatorAdmin from './TerminatorAdmin'
import TerminatorSendEmail from './TerminatorSendEmail'
import * as s from '../Eliminator/Admin/EliminatorAdmin.scss'
import * as summary from '../Eliminator/Admin/EliminatorConfigSummary.scss'

const TerminatorAdminDashboard = () => {
  const dispatch = useDispatch()
  const onlineUsers = useSelector(state => state.terminatorAdmin.onlineUsers)
  const navigate = useNavigate()
  const [config, setConfig] = useState(null)
  const [error, setError] = useState('')
  const [modal, setModal] = useState(null)
  useEffect(() => {
    let active = true
    dispatch(getConfig()).then(action => {
        const payload = action?.payload
        if (action?.error || !payload || payload.messageType === 'error') throw new Error(payload?.response?.message || payload?.message || 'Unable to load Terminator. Please try again.')
        return payload
      }).then(data => {
      if (active) setConfig({ ...(data.seasonConfig || data.config), terminatorServiceRunning: (data.seasonConfig || data.config)?.terminatorServiceRunning === true || (data.seasonConfig || data.config)?.terminatorServiceRunning === 'Yes' })
    }).catch(error => { if (active) setError(terminatorErrorMessage(error)) })
    return () => { active = false }
  }, [dispatch, modal])
  const season = encodeURIComponent(config?.seasonName || '')
  const buttons = [
    ['leaf', 'set active season', () => setModal('Set active season')],
    ['cog', 'edit configuration', () => setModal('Edit configuration')],
    ['envelope', 'send email', () => setModal('Send email')],
    ...(config?.seasonName ? [
      ['user-plus', 'register players', () => navigate(`/terminator/admin/register-players/${season}`)],
      ['list-alt', 'reminder log', () => navigate(`/terminator/admin/reminder-log/season/${season}/${config.seasonMode === 'Postseason' ? 'postseason' : 'regular'}/week/${config.seasonMode === 'Postseason' ? config.playoffWeek : config.week}`)],
      ['money-bill-alt', 'view payment log', () => navigate(`/terminator/admin/payments/${season}`)],
      ['check', 'manual pick entry', () => navigate(`/terminator/admin/manual-entry/${season}/${config.seasonMode === 'Postseason' ? 'Postseason' : 'Regular'}/${config.seasonMode === 'Postseason' ? `playoff-week/${config.playoffWeek}` : `week/${config.week}`}`)],
    ] : []),
  ]
  const values = config ? [
    ['Active season', config.seasonName || 'Not configured'],
    ['Elimination mode', Number(config.eliminationMode) === 1 ? 'Single' : Number(config.eliminationMode) === 2 ? 'Double' : 'Not configured'],
    ['Contest Start Week', config?.startWeek ?? 1],
    ['Season mode', config.seasonMode],
    ['Active Regular Season Week', config.week],
    ['Active Postseason Week', config.playoffWeek],
    ['Service running?', config.terminatorServiceRunning ? 'Yes' : 'No'],
    ['PayPal Event Name', config.payPalEventName],
    ['PayPal Email Account', config.payPalEmailAccount],
    ['Registration Code', config.registrationCode || 'Not set'],
    ['Entry Fee', `$${Number(config.entryFee).toFixed(2)}`],
    ['Front Page Message', config.frontPageMessage || 'Not set'],
  ] : []
  return <div className={s.container}>
    <div className={s.pageHeader}><div className={s.eyebrow}>Terminator Admin</div><h2>Dashboard</h2></div>
    {error ? <Alert variant='danger'>{error}</Alert> : null}
    <Row className={s.dashboardGrid}>
      <Col sm={6} xs={12}>
        <section className={s.adminCard}>
          <div className={summary.container}><h4>Configuration</h4>
            {!config && !error ? <p>Loading configuration…</p> : null}
            <ListGroup className={summary.list}>{values.map(([title, value]) =>
              <ListGroup.Item className={summary.item} key={title}><div className={summary.heading}>{title}</div><div className={summary.value}>{value}</div></ListGroup.Item>)}</ListGroup>
          </div>
          <ButtonGroup className={s.dashboardButtonContainer}>
            {buttons.map(([icon, title, onClick]) => <Button key={title} variant='light' className={s.button} onClick={onClick}><FontAwesomeIcon name={icon} />{' '}{title}</Button>)}
          </ButtonGroup>
        </section>
      </Col>
      <Col sm={6} xs={12}>
        <section className={s.adminCard + ' ' + s.onlineCard}><h4>Online Users</h4><OnlineUsers users={onlineUsers} /><SendPushNotification app='Terminator' /></section>
        <section className={s.adminCard + ' ' + s.loginsCard}><Logins isDashboard admins /></section>
        <section className={s.adminCard + ' ' + s.loginsCard}><Logins isDashboard /></section>
      </Col>
    </Row>
    <Modal heading={modal || ''} show={!!modal} onClose={() => setModal(null)} actionButtonText={null}>
      {modal === 'Set active season' ? <TerminatorSetActiveSeason /> : modal === 'Send email' ? <TerminatorSendEmail /> : modal ? <TerminatorAdmin /> : null}
    </Modal>
  </div>
}
export default TerminatorAdminDashboard
